import Layout from "../../components/Layout";
import MediaManager from "../../components/MediaManager";
import { Images } from "lucide-react";

export default function MediaLibrary() {
  return (
    <Layout>
      <div className="max-w-4xl" data-testid="media-library-page">
        <div className="flex items-center gap-2 text-[11px] uppercase tracking-widest text-[#C8A46B]/80 font-mono">
          <Images className="w-3.5 h-3.5" /> Media Library
        </div>
        <h1 className="text-3xl font-bold tracking-tight mt-1 mb-2">Files & Media</h1>
        <p className="text-sm text-slate-400 mb-6">
          A shared store for documents, images and media. Files can be kept private to the team
          or flipped to a public link to share externally.
        </p>
        <div className="card-dark p-5 border border-white/5">
          <MediaManager contextType="library" title="All Media" />
        </div>
      </div>
    </Layout>
  );
}
